import styled from '@emotion/styled';

const PostBody = styled.article`
  min-width: 220px;
  margin: auto auto;
  overflow-x: unset;
  color: inherit;
  max-width: 755px;

  span {
    background-color: transparent 
    color: white 
  }

  img {
    max-width: auto;
  }

  ul {
    color: inherit;
    margin-left: 2px;
    margin-bottom: 0px;
  }
  ul li {
    padding: ${props => (props.listItemIconURI ? `0px 2px 0px 38px` : `none`)};
    margin-left: ${props => (props.listItemIconURI ? `0px` : `20px`)};
    list-style: ${props => (props.listItemIconURI ? `none` : `auto`)};
    margin-bottom: 10px;
    line-height: 26px;
    background: ${props =>
      props.listItemIconURI ? `url(${props.listItemIconURI}) no-repeat left 1px` : `none`};
  }

  a {
    border-radius: 3px;
    color: white;
    text-align: center;
    color: inherit;
    padding: 0px 2px;
  }

  .video-root {
    margin: 0px auto;
    max-width: 720px;

    .video-wrapper {
      margin: 0px -20px;
      position: relative;
      padding-bottom: 56.25%;
      padding-top: 30px;
      height: 0;
      overflow: hidden;

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }

  p {
    position: relative;
    display: inline-block;
    margin-top: 0px;
    padding: 0;
    width: 100%;
    margin-bottom: 8px;

    a {
      margin: 0px 3px;
    }
  }

  h4,
  h3,
  h2,
  h1 {
    display: block;
    text-align: center;
    font-weight: 800;
    padding: 14px;
    margin: 10px;
    position: relative;
  }

  h1:after,
  h2:after {
    background-color: ${props => props.theme.primaryAccent || props.theme.primary};
    margin: 6px auto;
  }

  .image-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;

export default PostBody;
